// extracted by mini-css-extract-plugin
module.exports = {"sectionA8":"SectionA8_sectionA8__DCGgz"};